import CompanyService from "src/Services/API/company.service";

// The company's own wording for Makani's core concepts, chosen during
// onboarding. Cached in localStorage because it is read on nearly every render
// (menus, headers, buttons) and changes about once in a tenant's lifetime.
const VOCAB_KEY = "vocabulary";

// The wording a company gets until it says otherwise.
const DEFAULTS = {
  workOrder: "Work Order",
  serviceCall: "Service Call",
  tech: "Technician",
  asset: "Asset",
  truckStock: "Truck Stock",
  recommendation: "Recommendation",
};

export const getVocabulary = () => {
  try {
    return { ...DEFAULTS, ...(JSON.parse(localStorage.getItem(VOCAB_KEY)) || {}) };
  } catch (e) {
    return { ...DEFAULTS };
  }
};

export const setVocabulary = (vocabulary) => {
  localStorage.setItem(VOCAB_KEY, JSON.stringify(vocabulary || {}));
};

export const clearVocabulary = () => {
  localStorage.removeItem(VOCAB_KEY);
};

// Fetch the wording for the company the user is acting as. Failing is not fatal
// — the defaults stand — so callers don't need to guard the app on it.
export const loadVocabulary = async () => {
  try {
    const response = await CompanyService.getVocabulary();
    setVocabulary(response.data || {});
  } catch (e) {
    console.log("failed to load vocabulary: ", e);
  }
};

/** The company's word for a concept, e.g. term("workOrder") → "Job". */
export const term = (key) => getVocabulary()[key] || DEFAULTS[key] || "";

/**
 * The plural of that word, for list pages and menus. English-only and naive on
 * purpose: the words are short nouns the customer typed ("Job", "Event",
 * "Trouble Call"), so a proper inflection library would be all cost, no gain.
 */
export const termPlural = (key) => {
  const word = term(key);
  if (!word) return "";
  if (/(s|x|z|ch|sh)$/i.test(word)) return `${word}es`;
  if (/[^aeiou]y$/i.test(word)) return `${word.slice(0, -1)}ies`;
  return `${word}s`;
};
